/**
* handles the observing of the whole document (keyup, click, mouseout)
* how to use: i4l-wiki -> document listener
*/

var i4_Document_listener = {
	items: {
		keyup: {},
		click: {},
		mouseout: {}
	},
	item_index: 0,
	items_pause: {},
	
	keyup_handler: 0,
	click_handler: 0,
	mouseout_handler: 0,
	
	click_position: {},
	
	add: function(event_name, options) {
		var result = '';

		var items = this.items[event_name];
		items[this.item_index] = options;
		this.items[event_name] = items;
		result = { event_name: event_name, key: this.item_index };
		
		this.item_index++;
		
		return result;
	},
	
	remove: function(key) {
		try {
			delete this.items[key.event_name][key.key];
			delete this.items_pause[key.key];
		} catch (e) {
			// ignore
		}
	},
	
	stop: function(key) {
		var item = this.items[key.event_name][key.key];
		if (item) {
		    this.items_pause[key.key] = item;
		    delete this.items[key.event_name][key.key];
		}
	},
	
	start: function(key) {
		var item = this.items_pause[key.key];
		if (item) {
		    this.items[key.event_name][key.key] = item;
		    delete this.items_pause[key.key];
		}
	},
	
	run: function() {
		
		// keyup
        var keyupsObj = this.items.keyup;
		var keyups = Object.keys(keyupsObj).map(function(e) {
            return keyupsObj[e];
		});
		
		if (this.keyup_handler !== 0) {
		    this.keyup_handler.off('keyup');
		    this.keyup_handler = 0;
		} // if keyup_handler != 0
		
		if (keyups.length > 0) {
			this.keyup_handler = $(document).on('keyup', (function(event){

			    $(keyups).each(function(i, options) {			    
			    	if (options.callback) {
			    		var ok = false;
			    		
			    		if (options.keys.length > 0) {
			    			
			    			$(options.keys).each(function(i, item) {
			    				if (item == event.keyCode) {
			    					ok = true;
			    					return false;
			    				}
			    			});
			    			
			    		} else {
			    			ok = true;
			    		}
			    					    		
			    		if (ok) {
			    			options.callback();
			    		}
			    		
			    	}
			    });
			    
			}).bind(this));

		} 
		
		// click
        var clicksObj = this.items.click;
		var clicks = Object.keys(clicksObj).map(function(e) {
            return clicksObj[e];
        });
		
		if (this.click_handler !== 0) {
		    this.click_handler.off('click');
		    this.click_handler = 0;
		} // if click_handler != 0

		if (clicks.length > 0) {
			this.click_handler = $(document).on('click', (function(event){
		    
			    this.click_position = { top: event.pageY,  left: event.pageX };
			    
			    $(clicks).each(function(i, options) {
			    	if (options.callback) {
					    var ok = true;
					    if (options.exclude) {
					    	$(options.exclude).each(function(i, item) {						    	
						    	if ($(event.target).is(item) || $(event.target).parents(item).length > 0) {
							    	ok = false;
							    	return false;
						    	}
					    	});
					    }
					    					    
					    if (ok) {
					    	options.callback();
					    }
					    
					}
			    });
			    
			}).bind(this));

		}
		
		// mouseout
		var mouseoutsObj = this.items.mouseout;
        var mouseouts = Object.keys(mouseoutsObj).map(function(e) {
            return mouseoutsObj[e];
        });
		
		if (this.mouseout_handler !== 0) {
		    this.mouseout_handler.off('mousemove');
		    this.mouseout_handler = 0;
		} // if mouseout_handler != 0
		
		if (mouseouts.length > 0) {
			this.mouseout_handler = $(document).on('mousemove', (function(event){

			    $(mouseouts).each(function(i, options) {
			    	if (options.callback) {
					    var ok = false;
							
						var distance = 0;
						if (options.distance) {
						    distance = options.distance;
						}
						
						if (options.element) {
						    var pointer = {
							    x: event.pageX,
							    y: event.pageY
						    };
						    
						    var measure_left = $(options.element).offset().left;
						    var measure_top = $(options.element).offset().top;
						    
						    var x_min = measure_left-distance;
						    var x_max = measure_left+$(options.element).width()+distance;
						    var y_min = measure_top-distance;
						    var y_max = measure_top+$(options.element).height()+distance;
						    
						    if (!(pointer.x > x_min && pointer.x < x_max) || !(pointer.y > y_min && pointer.y < y_max)) {
						    	ok = true;
						    }
						    
						} 
						
						if (ok) {
						    options.callback();
						}
					    
					}
			    });
			    
			}).bind(this));

		}
	}, 
	
	get_click_position: function() { return this.click_position; },
	set_click_position: function(position) { this.click_position = position; }
};
